import { createFileRoute } from "@tanstack/react-router";
import SupplierManager from "@/features/inventory/SupplierManager";

export const Route = createFileRoute("/inventory/suppliers")({
  component: SettingsSuppliersPage,
});

function SettingsSuppliersPage() {
  return (
    <div className="gap-4 flex flex-col grow min-h-0 h-full">
      <SupplierManager onClose={() => {}} />
    </div>
  );
}
